import React, { useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import setcLogo from '../assets/images/craig_setcLogo.png'
import { apiURL } from '../utilities/URLs'
import { useTheme } from '../ThemeContext'

export default function ResetPassword() {
  const { token } = useParams()
  const navigate = useNavigate()
  const { isDarkMode } = useTheme()

  const [newPassword, setNewPassword] = useState('')
  const [confirmNewPassword, setConfirmNewPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState('')

  const handleSubmit = async () => {
    if(newPassword === confirmNewPassword) {
      setLoading('Resetting Password...')

      const newPasswordInfo = {
        token: token,
        newPassword: newPassword
      }

      const formData = new FormData()
      formData.append('newPasswordInfo', JSON.stringify(newPasswordInfo))


      const updatedPasswordResponse = await fetch(`${apiURL}/api/resetPassword`, {
        method: 'PUT',
        body: formData
      })

      const updatedPasswordData = await updatedPasswordResponse.json()

      if(updatedPasswordData.response.error) {
        setLoading('')
        setError(updatedPasswordData.response.error)
        setTimeout(() => {
          setError('')
        }, 2000)
      } else {
        setLoading('Password Reset Successful! Redirecting Back To Login Page...')
        setTimeout(() => {
          navigate('/affiliate')
        }, 2000)
      }
    } else {
      setError('Passwords Do Not Match')
      setTimeout(() => {
        setError('')
      }, 2000)
    }
  }

  return (
    <div className='flex flex-col items-center justify-center h-svh'>
      <img className='w-60 mb-28' src={setcLogo} alt='setcLogo' />
      <div className={`w-full max-w-xs p-8 rounded-lg shadow mb-28 ${isDarkMode ? 'bg-gray-800' : 'bg-white'}`}>
        <h1 className='mb-10 font-semibold text-lg text-center'>Reset Password</h1>
        <div className='mb-4'>
          <label htmlFor='newPassword' className={`block mb-2 text-sm font-bold text-left ${isDarkMode ? 'text-white' : 'text-gray-700'}`}>
            New Password
          </label>
          <input
            type='password'
            id='newPassword'
            className={`w-full px-3 py-2 leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline ${isDarkMode && 'bg-gray-800 text-white'}`}
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            required
          />
        </div>
        <div className='mb-4'>
          <label htmlFor='confirmNewPassword' className={`block mb-2 text-sm font-bold text-gray-700 text-left ${isDarkMode ? 'text-white' : 'text-gray-700'}`}>
            Confirm New Password
          </label>
          <input
            type='password'
            id='confirmNewPassword'
            className={`w-full px-3 py-2 leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline ${isDarkMode && 'bg-gray-800 text-white'}`}
            value={confirmNewPassword}
            onChange={(e) => setConfirmNewPassword(e.target.value)}
            required
          />
        </div>
        <div className='flex justify-center'>
          <button onClick={() => handleSubmit()} type='submit' className='px-4 py-2 font-bold text-white bg-blue-500 rounded hover:bg-blue-700 focus:outline-none focus:shadow-outline mt-5'>
            Request Reset
          </button>
        </div>
        {loading.length > 0 && (
          <p className={`mt-5 ${isDarkMode && 'text-white'}`}>{loading}</p>
        )}
        {error.length > 0 && (
          <p className='text-red-600 mt-5'>{error}</p>
        )}
      </div>
    </div>
  )
}